import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { TfiClose } from "react-icons/tfi";
import { removeMovie } from "../Features/cart/cartslice";
import { clearCart } from "../Features/cart/cartslice";

const CartPage = () => {
  const cartDetails = useSelector((state) => state.cart.cart);
  const dispatch = useDispatch();

  function removeMovieFromCart(id) {
    dispatch(removeMovie(id));
  }

  function removeAllMovieFromCart() {
    dispatch(clearCart());
  }

  return (
    <div>
      <h1
        style={{
          color: "#fff",
          textAlign: "center",
          padding: "2rem",
          height: "20vh",
        }}
      >
        {cartDetails.length === 0
          ? "No Movies Added In Watchlist"
          : `You have ${cartDetails.length} ${
              cartDetails.length > 1 ? "Movies" : "Movie"
            } in your watchlist`}
      </h1>
      <div className="main-cart-container">
        {cartDetails.length > 0 ? (
          <div className="clear-cart-box">
            <button onClick={() => removeAllMovieFromCart()}>Clear Cart</button>
          </div>
        ) : (
          ""
        )}

        {cartDetails &&
          cartDetails.map((movie) => (
            <div className="cart-container">
              <div className="cart-image-box">
                <img
                  src={`https://image.tmdb.org/t/p/original${movie.poster_path}`}
                  alt="movie"
                />
              </div>
              <div className="cart-detail-box">
                <div className="cart-title-rating-box">
                  <p className="cart-title">{movie.title}</p>
                  <p className="cart_rating">
                    {" "}
                    {movie.vote_average} <i className="fa fa-star"></i>
                  </p>
                </div>
                <div className="cart-desc-box">
                  <p className="cart-desc">{movie.overview.slice(0, 100)}...</p>
                </div>
                <p
                  onClick={() => removeMovieFromCart(movie.id)}
                  className="cart-close"
                  style={{ color: "red" }}
                >
                  Remove <TfiClose />
                </p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default CartPage;
